import { createFileRoute } from '@tanstack/react-router';

import Loading from '@/_pages/companies/api-integration/loading';
import { getCompanyQueryOptions } from '@/_pages/companies/api-service';

export const Route = createFileRoute('/_private/companies/_template/$id/api-integration')({
  loader: (opts) => opts.context.queryClient.ensureQueryData(getCompanyQueryOptions(opts.params.id)),
  staticData: {
    pageTitle: 'API Integrations',
    tabKey: 'client/api-integration',
  },
  pendingComponent: Loading,
});
